import USER_TYPE from "$types/USER_TYPE"
import { getForm, getFormCurrentValues, getFormInitialValues } from "./form"

declare global {
  interface Window {
    handleUserTypeRadioChange: (formId: string) => void
  }
}

window.handleUserTypeRadioChange = (formId) => {
  const form = getForm(formId)

  const formInitialValues = getFormInitialValues(form)
  const formValues = getFormCurrentValues(formInitialValues, form)

  const userType = formValues["userType"]

  const selectOrganizationContainerHidden = userType === USER_TYPE.STAFF

  const selectOrganizationContainer = form.querySelector("#select-organization-container")

  if (selectOrganizationContainer) {
    const shouldDisable = selectOrganizationContainerHidden

    const selectWrap = selectOrganizationContainer.querySelector(".select__wrap")
    if (selectWrap) {
      selectWrap.classList.toggle("select__wrap--disabled", shouldDisable)
    }

    const selectDropdownItems = selectOrganizationContainer.querySelectorAll(".dropdown__item")
    selectDropdownItems.forEach(item => {
      item.classList.toggle("dropdown__item--disabled", shouldDisable)
      if (shouldDisable) {
        item.classList.remove("dropdown__item--selected")
        item.setAttribute("onclick-backup", item.getAttribute("onclick") || "")
        item.removeAttribute("onclick")
      } else {
        const original = item.getAttribute("onclick-backup")
        if (original) {
          item.setAttribute("onclick", original)
        }
      }
    })

    const hiddenInput = selectOrganizationContainer.querySelector(".select__container input[type='hidden']") as HTMLInputElement
    if (hiddenInput) {
      hiddenInput.disabled = shouldDisable
      if (shouldDisable) hiddenInput.value = ""
    }

    const textInput = selectOrganizationContainer.querySelector(".select__container__inner input[type='text']") as HTMLInputElement
    if (textInput) {
      textInput.disabled = shouldDisable
      textInput.setAttribute("aria-disabled", shouldDisable.toString())
      if (shouldDisable) textInput.value = ""
    }

    const dropdownTrigger = selectOrganizationContainer.querySelector(".select__icon")
    if (dropdownTrigger) {
      dropdownTrigger.classList.toggle("pointer-events-none", shouldDisable)
      dropdownTrigger.classList.toggle("opacity-50", shouldDisable)
    }
  }

  window.onFormUpdate(form)
}
